import { useContext, useEffect, useMemo, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import React from "react";
import { colors } from "../../common/styles/colors";
import { api } from "../../api/api";
import { VotingContext } from "./VotingNavigation";
import {
  Dimensions,
  View,
  Text,
  Linking,
  StyleProp,
  ViewStyle,
  TouchableOpacity,
} from "react-native";
import { PhotoCarousel } from "../../components/PhotoCarousel";
import { CommonLoading } from "../../components/CommonLoading";
import { fonts } from "../../common/styles/fonts";
import { CommonButton } from "../../components/buttons";
import { MapLight } from "../../common/icons/MapLight";
import { MapBlack } from "../../common/icons/MapBlack";
import { TagsWithDivider, usePlaceTags } from "../../components/PlaceCard";
import { ShareLight } from "../../common/icons/ShareLight";
import { ShareBlack } from "../../common/icons/ShareBlack";
import { Place_Place__component } from "../../api/models/Place_Place__component";
import { CrossBlack } from "../../common/icons/CrossBlack";
import { ReturnBlack } from "../../common/icons/ReturnBlack";
import { HeartBlack } from "../../common/icons/HeartBlack";

// let index = 0
const UnmapPlacesIds = (places_ids: any) =>
  Object.entries(places_ids)
    .filter(([key, value]) => value)
    .map(([key, value]) => Number(key));

export const ActionPage = () => {
  const { setIsLoading, meeting, setVoteId, name, isLoading, getMeeting } =
    useContext(VotingContext);

  const navigate = useNavigate();
  const { meetingUuid } = useParams<{ meetingUuid: string }>();

  const [data, setData] = useState({
    username: name,
    places_ids: {} as { [id: number]: boolean },
  });
  const [index, setIndex] = useState(0);

  const voteBall = (placeId: string, vote: boolean) => {
    setIsLoading(false);
    setData({
      ...data,
      places_ids: { ...data.places_ids, [placeId]: vote },
    });
    index + 1 <= (meeting?.places?.length || 0) && setIndex(index + 1);
  };

  useEffect(() => {
    if (meeting && meeting?.places?.length === index && meeting.id) {
      // @ts-ignore
      setIndex(true);
      setIsLoading(true);

      api.meetings
        .putApiMeetingsIdVote(meeting.id, {
          ...data,
          placed_id: UnmapPlacesIds(data.places_ids),
        })
        .then((res) => {
          setVoteId(res.data?.vote?.id);
          setIsLoading(false);

          navigate(`../app/phone`, { replace: true });
        });
    }
  }, [index, isLoading, meeting]);

  const currentPlace = useMemo(
    () =>
      meeting &&
      meeting.places &&
      (meeting?.places?.length === index
        ? meeting.places[index - 1]
        : meeting.places[index]),
    [meeting, index]
  );

  const onDownVote = (placeId: string) => {
    voteBall(placeId, false);
  };

  const onUpVote = (placeId: string) => {
    voteBall(placeId, true);
  };

  // @ts-ignore
  const filteredPictures: string[] = useMemo(
    () =>
      currentPlace
        ? [
            currentPlace.picture_1,
            currentPlace.picture_2,
            currentPlace.picture_3,
          ].filter((img) => !!img)
        : [],
    [currentPlace]
  );

  useEffect(() => {
    if (!meeting && meetingUuid) {
      getMeeting(meetingUuid);
    }
  }, [meetingUuid]);

  return (
    <>
      {isLoading ? (
        <CommonLoading />
      ) : (
        <View
          style={{
            height: Dimensions.get("window").height,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View
            style={{
              height: "100%",
              maxWidth: 500,
              width: "100%",
            }}
          >
            <PhotoCarousel
              data={filteredPictures}
              containerStyle={{
                borderRadius: 0,
              }}
              style={{
                width: "100%",
                aspectRatio: 1,
              }}
              overlay
            />

            {currentPlace && (
              <PlaceInfo
                style={{
                  marginHorizontal: 12,
                  marginTop: 12,
                  marginBottom: 24,
                }}
                place={currentPlace}
              />
            )}

            {currentPlace && (
              <View
                style={{
                  paddingBottom: 24,
                  marginHorizontal: 30,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <TouchableOpacity
                  onPress={() => onDownVote(currentPlace.place_id)}
                >
                  <CrossBlack />
                </TouchableOpacity>

                {index !== 0 && (
                  <TouchableOpacity
                    onPress={() => index && setIndex(index - 1)}
                  >
                    <ReturnBlack />
                  </TouchableOpacity>
                )}

                <TouchableOpacity
                  onPress={() => onUpVote(currentPlace.place_id)}
                >
                  <HeartBlack />
                </TouchableOpacity>
              </View>
            )}
          </View>
        </View>
      )}
    </>
  );
};

const PlaceInfo = ({
  place,
  style,
}: {
  place: Place_Place__component;
  style?: StyleProp<ViewStyle>;
}) => {
  const tags = usePlaceTags(place);
  const [descriptionExtended, setDescriptionExtended] = useState(false);

  useEffect(() => {
    setDescriptionExtended(false);
  }, [place]);

  return (
    <View style={style}>
      <Text
        numberOfLines={1}
        style={{ color: colors.black, ...fonts.averageLargeText_bold }}
      >
        {place.name}
      </Text>

      {place.address && (
        <CommonButton
          onPress={() => {
            Linking.openURL(
              "https://maps.google.com?q=" +
                place.latitude +
                "," +
                place.longitude
            );
          }}
          style={{
            marginTop: 8,
            zIndex: 2,
            alignSelf: "flex-start",
            width: "100%",
          }}
          LeftIcon={<MapBlack style={{ marginRight: 4 }} />}
          textStyle={[fonts.smallMediumText_bold, {}]}
          containerStyle={{
            paddingHorizontal: 12,
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
          title={place.address}
          size={"small"}
          type={"black"}
        />
      )}

      <View
        style={{
          marginVertical: 12,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <TagsWithDivider
          textStyle={{ color: colors.black }}
          dividerStyle={{ backgroundColor: colors.black }}
          style={{ flex: 1 }}
          tags={tags}
        />

        {place.menu && (
          <CommonButton
            onPress={() => Linking.openURL(place.menu || "")}
            RightIcon={<ShareBlack style={{ marginLeft: 4 }} />}
            containerStyle={{ paddingHorizontal: 8 }}
            textStyle={fonts.mediumText_bold}
            style={{ zIndex: 2 }}
            type={"black"}
            size={"small"}
            title={"menu"}
          />
        )}
      </View>

      <Text
        numberOfLines={!descriptionExtended ? 3 : undefined}
        style={[fonts.smallMediumText_regular, { color: colors.black }]}
      >
        {place.description}
      </Text>

      {!descriptionExtended && (
        <Text
          onPress={() => setDescriptionExtended(true)}
          style={[fonts.smallMediumText_bold, { color: colors.black }]}
        >
          learn more
        </Text>
      )}
    </View>
  );
};
